import { toast } from 'sonner';

export interface DataProduct {
  nNF: string;
  emit_IE: string;
  dest_CNPJ: string;
  dest_CPF: string;
  dest_IE: string;
  items: Item[];
}

interface Item {
  cProd: string;
  xProd: string;
  qCom: string;
  uCom: string;
}

export const useFiles = () => {
  const DOMToObject = (
    xmlDoc: Document,
    fileName?: string
  ): DataProduct | null => {
    const items = Array.from(xmlDoc.getElementsByTagName('det'))?.map(
      (item) => ({
        cProd: item.getElementsByTagName('cProd')[0].textContent as string,
        xProd: item.getElementsByTagName('xProd')[0].textContent as string,
        qCom: item.getElementsByTagName('qCom')[0].textContent as string,
        uCom: item.getElementsByTagName('uCom')[0].textContent as string,
      })
    );

    const dataProduct = {
      nNF: xmlDoc.getElementsByTagName('nNF')[0]?.textContent as string,
      emit_IE: xmlDoc
        .getElementsByTagName('emit')[0]
        ?.getElementsByTagName('IE')[0]?.textContent as string,
      items,
    };

    const dataDest = {
      dest_CPF:
        (xmlDoc.getElementsByTagName('dest')[0]?.getElementsByTagName('CPF')[0]
          ?.textContent as string) || '',
      dest_IE: xmlDoc
        .getElementsByTagName('dest')[0]
        ?.getElementsByTagName('IE')[0]?.textContent as string,
      dest_CNPJ: xmlDoc
        .getElementsByTagName('dest')[0]
        ?.getElementsByTagName('CNPJ')[0]?.textContent as string,
    };

    const invalidValues = Object.entries(dataProduct)
      .filter(([_, value]) => value === undefined)
      .map(([key]) => key);

    const invalidDest = Object.entries(dataDest).every(([_, value]) => !value);

    if (invalidValues.length) {
      toast.error(`XML fora do padrão - ${fileName || ''}`);
      console.error('Empty XML keys', invalidValues);
      return null;
    } else if (!items.length) {
      toast.error(`XML sem produtos - ${fileName || ''}`);
      return null;
    } else if (invalidDest) {
      toast.error(`XML sem destino - ${fileName || ''}`);
      return null;
    }

    return { ...dataProduct, ...dataDest };
  };

  const readFiles = async (
    files: File[]
  ): Promise<Array<DataProduct | null>> => {
    return await Promise.all(
      files.map(
        (file) =>
          new Promise<DataProduct | null>((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e) => {
              const xml = e.target?.result;
              const parser = new DOMParser();
              const xmlDoc = parser.parseFromString(
                xml as string,
                'application/xml'
              );

              resolve(DOMToObject(xmlDoc, file.name));
            };

            reader.readAsText(file);

            reader.onerror = (err) => {
              console.log('erro ao ler arquivo', err.target?.error);
              reject(err.target?.error);
            };
          })
      )
    );
  };

  return {
    readFiles,
  };
};

export type AuthHook = ReturnType<typeof useFiles>;
